module.exports = __webpack_public_path__ + "static/media/cms.083d71cd.png";